__turbopack_context__.v({
  "cancel": "PortalBookingCancel-module__ljmGXa__cancel",
});
